/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchform.js
 */
$.namespace("SCS.header");

SCS.header.changeheaderurl = function(lang)
{
	SCS.header.changeurl("osn_meta_overview_language_"+lang);
};

SCS.header.changeurl = function(id)
{
	if($("#"+id))
	{
		var hrefval = $("#"+id).attr("orighref");
		
		if(!hrefval)
		{
			hrefval = $("#"+id).attr("href");
			$("#"+id).attr("orighref", hrefval);
		}
		$("#"+id).attr("href", hrefval + location.hash);
	}
};

SCS.header.changeprinturl = function(id)
{
	if($("#"+id))
	{
		var hrefval = $("#"+id).attr("orighref");
		
		if(!hrefval)
		{
			hrefval = $("#"+id).attr("href");
			
			var start = hrefval
			
			$("#"+id).attr("orighref", hrefval);
		}
		var st1 = "javascript:SCS.openPrint('";
		var st2 = "','Portrait')";
		var st3 = "document.location.hash,'Portrait')";
		var len = hrefval.length - st3.length;
		var start = hrefval.substring(0,len) + "'";
		var newurl = start + location.hash + st2;
				
		$("#"+id).attr("href", newurl);
	}
}


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/shared/js/headerurls.js
// module id = 346
// module chunks = 0